<mat-progress-bar
    class="progress-bar"
    mode="determinate"
    [value]="progressValue"></mat-progress-bar>
